module.exports = __webpack_public_path__ + "static/media/logo_vietcredit.829eea7a.svg";